import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramDraft } from "services";

import { GET_CARBON_PROGRAM_DRAFT } from "consts";

import { CarbonProgramDraftDetails } from "models";

export const useGetCarbonProgramDraft = (id?: string) =>
  useQuery<CarbonProgramDraftDetails | null>({
    queryKey: [GET_CARBON_PROGRAM_DRAFT, id],
    queryFn: () => (id ? getCarbonProgramDraft(id) : null),
    enabled: !!id,
    refetchOnMount: "always",
  });
